import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SafeHarborPlans } from "client/app/domains/SafeHarborPlans";
import { SafeHarborRequest } from "client/app/domains/SafeHarborRequest";
import { SafeHarborService } from "../service/safeHarbor.service";
import { GemsService } from "client/app/shared";
import { concatMap, map, tap } from "rxjs/operators";

@Component({
  selector: 'app-complete',
  templateUrl: './complete.component.html',
  styleUrls: ['../../../shared/styles/aa.less'],
  standalone: false
})
export class CompleteComponent implements OnInit {
  @Input() shSelected: SafeHarborPlans[];
  @Input() shReleaseDate: string;
  @Input() shEffectiveDate: string;
  @Output() back = new EventEmitter<boolean>();

  dontShowSummary = true;
  showConfirmMessage = true;

  alert: { caption?: string; text?: string };

  constructor(
    private safeHarborService: SafeHarborService,
    private gemsService: GemsService
  ) { }

  ngOnInit(): void {
    this.alert = {
      text: "Please double-check all of the information below before confirming the transaction."
    };
  }

  navigateBack() {
    this.back.emit(true);
  }

  submitSubgroups() {
    var documentIds: string[] = [];

    for (let i = 0; i < this.shSelected.length; i++) {
      documentIds.push(this.shSelected[i].DocumentId)
    }

    this.gemsService.getUser().pipe(
      map(user => ({
        DocumentIds: documentIds,
        EffectiveDate: this.shEffectiveDate,
        ReleaseDate: this.shReleaseDate,
        SubmittedBy: user.person_id
      } as SafeHarborRequest)
      ),
      tap(safeHarborRequest => console.table(safeHarborRequest)),
      concatMap(safeHarborRequest => this.safeHarborService.submitSafeHarborNotices(safeHarborRequest))
    ).subscribe((res: any) => {
      this.dontShowSummary = false;
      this.showConfirmMessage = false;
    });
  }
}